"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.1 25",
    width: "28.1",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M2.3,21.4C2.3,21.4,2.3,21.4,2.3,21.4c-0.5,0-1-0.2-1.3-0.5c-0.7-0.7-0.7-1.9,0-2.6l6-6 c0.1-0.1,0.2-0.1,0.4-0.1l0,0c0.1,0,0.3,0.1,0.4,0.1l1.9,1.9c0.2,0.2,0.2,0.5,0,0.7l-6,6C3.3,21.2,2.8,21.4,2.3,21.4z M7.3,13.3 L1.7,19c-0.3,0.3-0.3,0.9,0,1.2c0.2,0.2,0.4,0.3,0.6,0.3c0,0,0,0,0,0c0.2,0,0.4-0.1,0.6-0.3h0l5.6-5.6L7.3,13.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M10.2,16c-0.1,0-0.3,0-0.4-0.1L6,12c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l3.8,3.9 c0.2,0.2,0.2,0.5,0,0.7C10.5,16,10.4,16,10.2,16z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "6.3",
    y: "8.3",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -2.3378 11.8665)",
    fill: "#9ECE06",
    width: "13.7",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M19.1,5.5c-0.1,0-0.3-0.1-0.4-0.1l-2.2-2.2c-0.1-0.1-0.2-0.2-0.1-0.4c0-0.1,0.1-0.3,0.2-0.4l3.2-2.2 C20,0,20.2,0,20.4,0.1l1.4,1.4c0.2,0.2,0.2,0.5,0,0.7l-2.3,3.1C19.4,5.4,19.3,5.5,19.1,5.5C19.1,5.5,19.1,5.5,19.1,5.5z M17.6,2.8L19,4.2l1.7-2.3L20,1.1L17.6,2.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M8.6,11.2L5.4,8.1c-1.5,0.5-3.1,0.1-4.2-1C0,5.9-0.3,4.1,0.3,2.6c0.1-0.2,0.2-0.3,0.4-0.3 c0.2,0,0.3,0,0.4,0.1L2.9,4H4V2.9L2.4,1.1C2.3,1,2.3,0.8,2.3,0.7s0.1-0.3,0.3-0.4C4.1-0.3,5.8,0,7,1.2c1.1,1.1,1.5,2.7,1,4.2 l3.2,3.2l-0.7,0.7L7.1,5.9C7,5.8,6.9,5.5,7,5.4c0.5-1.2,0.2-2.5-0.7-3.4c-0.7-0.7-1.7-1-2.7-0.9l1.2,1.3C4.9,2.5,5,2.6,5,2.7v1.8 C5,4.8,4.8,5,4.5,5H2.7C2.5,5,2.4,5,2.3,4.9L1,3.7c-0.2,1,0.2,2,0.9,2.7C2.8,7.3,4.2,7.5,5.4,7C5.5,7,5.8,7,5.9,7.1l3.4,3.4 L8.6,11.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M16.2,14.8c-0.1,0-0.3-0.1-0.4-0.1l-3.4-3.4l0.7-0.7l3.2,3.2c0.4-0.1,0.8-0.2,1.2-0.2l0,1 c-0.4,0-0.8,0.1-1.1,0.2C16.3,14.8,16.3,14.8,16.2,14.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M14.7,20.5c-1.1-1.1-1.5-2.7-1-4.2l-3.2-3.2l0.7-0.7l3.4,3.4c0.1,0.1,0.2,0.4,0.1,0.5 c-0.5,1.2-0.2,2.5,0.7,3.4L14.7,20.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.2,25c-3.3,0-5.9-2.7-5.9-5.9c0-3.3,2.7-5.9,5.9-5.9s5.9,2.7,5.9,5.9C28.1,22.3,25.5,25,22.2,25z M22.2,14.1 c-2.7,0-4.9,2.2-4.9,4.9s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9S24.9,14.1,22.2,14.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.7,21.5c-0.1,0-0.3-0.1-0.3-0.1l-2.7-2.6c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l2.3,2.2l3.4-3.6 c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-3.7,4C21.9,21.5,21.8,21.5,21.7,21.5C21.7,21.5,21.7,21.5,21.7,21.5z"
  }));
};

exports["default"] = _default;